import { render, staticRenderFns } from "./ClusterInfo.vue?vue&type=template&id=01fb01f0"
import script from "./ClusterInfo.vue?vue&type=script&lang=js"
export * from "./ClusterInfo.vue?vue&type=script&lang=js"
import style0 from "./ClusterInfo.vue?vue&type=style&index=0&id=01fb01f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports